/* ══════════════ Derselbe Auftrag, aber mit dem Blatt (D-22/D-61) ══════════════

   Die Fälle „Ohne Unterschrift", „Ohne Pflichtfoto", „Nachtanken" und
   „Schaden" tragen seit dem 03.10.2026 einen Weg mit Zusatz
   (`/auftraege/V-…?protokoll=<id>` bzw. `?fotos=<belegung>`). Am Auftrag
   selbst hieß das bisher: „man ist schon da, kein Knopf" — dabei fehlt dort
   gerade der Griff ins Blatt. Ohne Abhängigkeiten, damit es ohne React und
   Router prüfbar ist (`test/fallweg-blatt.test.ts`). */

/**
 * Was der Knopf am Auftrag tut, wenn der Weg eines Falls hierher zeigt:
 * - `"keiner"` — derselbe Weg ohne Zusatz, man ist schon da;
 * - `"blatt"` — derselbe Auftrag mit Zusatz, der Knopf schlägt das Blatt auf;
 * - `"anderswo"` — ein anderer Ort.
 */
export function wegHier(weg: string, hier: string): "keiner" | "blatt" | "anderswo" {
  if (weg === hier) return "keiner";
  return weg.split("?")[0] === hier ? "blatt" : "anderswo";
}
